module.exports = __webpack_public_path__ + "static/img/news5-cover.f92c4d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news5-cover.jpg
// module id = IjrX
// module chunks = 0